import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { useAuthenticator } from "@aws-amplify/ui-react";
import ContentLayoutFooterNoChartreuse from "../components/Layout/ContentLayoutFooterNoChartreuse";
import GalleryComponent from "../components/Carousel/Gallery";

function Gallery() {
  const router = useRouter();
  const { authStatus, user } = useAuthenticator((context) => [
    context.authStatus,
    context.user,
  ]);

  useEffect(() => {
    if (authStatus === "unauthenticated") {
      router.push("/login");
    }
  }, [authStatus, user, router]);

  return (
    <ContentLayoutFooterNoChartreuse title="Gallery">
      <GalleryComponent />
    </ContentLayoutFooterNoChartreuse>
  );
}

export default Gallery;
